import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../index';
import { scan2DaveFeatureKey, Scan2DaveState } from '../reducers/scan2dave.reducer';

export const selectScan2Dave = createFeatureSelector< Scan2DaveState>(scan2DaveFeatureKey);
export const getScan2DaveEmail = createSelector(selectScan2Dave, data => data.scan2DaveEmail);
